import React, { useState } from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import "../../../assets/styles/SupervisorPanel.css";

const SupervisorPanelSports = () => {
  const [requests, setRequests] = useState([
    {
      id: 1,
      section: "Football",
      time: "6:00 PM - 7:00 PM",
      date: "Tuesday, Oct 28",
      captain: { name: "Ahmed Yasser", studentId: "12345" },
      members: Array.from({ length: 10 }, (_, i) => ({
        name: `Member ${i + 1}`,
        id: 2000 + i,
      })),
      status: "pending",
    },
    {
      id: 2,
      section: "Basketball",
      time: "7:00 PM - 8:00 PM",
      date: "Tuesday, Oct 28",
      captain: { name: "Mohamed Ali", studentId: "67890" },
      members: Array.from({ length: 10 }, (_, i) => ({
        name: `Player ${i + 1}`,
        id: 3000 + i,
      })),
      status: "pending",
    },
    {
      id: 3,
      section: "Volleyball",
      time: "5:00 PM - 6:00 PM",
      date: "Wednesday, Oct 29",
      captain: { name: "Omar Khaled", studentId: "11223" },
      members: Array.from({ length: 10 }, (_, i) => ({
        name: `Teammate ${i + 1}`,
        id: 4000 + i,
      })),
      status: "pending",
    },
  ]);

  const [selectedTeam, setSelectedTeam] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [loadingId, setLoadingId] = useState(null);

  const handleViewTeam = (team) => {
    setSelectedTeam(team);
    setShowModal(true);
  };

  const handleAccept = async (id) => {
    if (!window.confirm("Are you sure you want to accept this team?")) return;

    setLoadingId(id);
    await new Promise((res) => setTimeout(res, 1000)); // Loader 1s

    const updated = requests.map((req) =>
      req.id === id ? { ...req, status: "accepted" } : req
    );
    setRequests(updated);
    setLoadingId(null);
  };

  const handleReject = async (id) => {
    if (!window.confirm("Are you sure you want to reject this team?")) return;

    setLoadingId(id);
    await new Promise((res) => setTimeout(res, 1000)); // Loader 1s

    const updated = requests.filter((req) => req.id !== id);
    setRequests(updated);
    setLoadingId(null);
  };

  // الأقسام المختلفة
  const sections = ["Football", "Basketball", "Volleyball"];
  const [activeSection, setActiveSection] = useState("Football");

  return (
    <div className="supervisor-panel container py-4">
      <div className="section-tabs d-flex justify-content-center gap-2 mb-4 flex-wrap">
        {sections.map((sec) => (
          <Button
            key={sec}
            variant={activeSection === sec ? "primary" : "outline-primary"}
            className="rounded-pill px-4"
            onClick={() => setActiveSection(sec)}
          >
            {sec === "Football"
              ? "⚽ Football"
              : sec === "Basketball"
              ? "🏀 Basketball"
              : "🏐 Volleyball"}
          </Button>
        ))}
      </div>

      <div className="row g-3">
        {requests.filter((r) => r.section === activeSection).length === 0 ? (
          <div className="text-center text-muted py-5 fw-medium">
            No requests available for this section.
          </div>
        ) : (
          requests
            .filter((r) => r.section === activeSection)
            .map((req) => (
              <div className="col-md-6 col-lg-4" key={req.id}>
                <div
                  className={`supervisor-card border-start border-4 shadow-sm p-3 bg-white rounded ${
                    req.status === "accepted"
                      ? "border-success"
                      : req.status === "pending"
                      ? "border-warning"
                      : "border-danger"
                  }`}
                >
                  <div className="d-flex justify-content-between align-items-start mb-2 flex-wrap">
                    <h5 className="fw-bold text-blue mb-1">{req.section}</h5>
                    <span
                      className={`status-badge ${
                        req.status === "accepted"
                          ? "accepted"
                          : req.status === "pending"
                          ? "pending"
                          : "rejected"
                      }`}
                    >
                      {req.status.charAt(0).toUpperCase() + req.status.slice(1)}
                    </span>
                  </div>

                  <p className="small mb-1">
                    <strong>Date:</strong> {req.date}
                  </p>
                  <p className="small mb-1">
                    <strong>Time:</strong> {req.time}
                  </p>
                  <p className="small mb-2">
                    <strong>Captain:</strong> {req.captain.name} (ID:{" "}
                    {req.captain.studentId})
                  </p>

                  <div className="d-flex justify-content-between mt-3 flex-wrap gap-2">
                    <Button
                      variant="outline-info"
                      size="sm"
                      onClick={() => handleViewTeam(req)}
                    >
                      👥 View Team
                    </Button>

                    <div className="d-flex gap-2">
                      <Button
                        variant="success"
                        size="sm"
                        disabled={req.status !== "pending" || loadingId === req.id}
                        onClick={() => handleAccept(req.id)}
                      >
                        {loadingId === req.id ? (
                          <Spinner size="sm" animation="border" />
                        ) : (
                          "Accept"
                        )}
                      </Button>
                      <Button
                        variant="danger"
                        size="sm"
                        disabled={req.status !== "pending" || loadingId === req.id}
                        onClick={() => handleReject(req.id)}
                      >
                        {loadingId === req.id ? (
                          <Spinner size="sm" animation="border" />
                        ) : (
                          "Reject"
                        )}
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            ))
        )}
      </div>

      {/* مودال عرض الفريق */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        className="team-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title className="fw-bold text-blue">
            👥 Team Members
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedTeam && (
            <div>
              <p className="mb-1">
                <strong>Captain:</strong> {selectedTeam.captain.name} (ID:{" "}
                {selectedTeam.captain.studentId})
              </p>
              <p className="small-muted mb-3">
                <strong>Section:</strong> {selectedTeam.section}
              </p>

              <ul className="list-group small">
                {selectedTeam.members.map((m, index) => (
                  <li key={index} className="list-group-item">
                    {index + 1}. {m.name} (ID: {m.id})
                  </li>
                ))}
              </ul>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SupervisorPanelSports;
